import styled from 'styled-components';

export const SocialMediaRequestsSection = styled.div`
    width: 100%;
`;

export const SocialMediaRequestsWrap = styled.div`
    width: 100%;
`;

export const SocialMediaRequestsTitle = styled.h2`
    width: 100%;
    max-width: 360px;
    color: #333333;
    font-size: 20px;
    font-weight: 700;
    font-family: 'Jost', sans-serif;
    line-height: 30px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }

    @media screen and (max-width: 575px){
        font-size: 18px;
        line-height: 26px;
    }
`;

export const SocialMediaMain = styled.div`
    width: 100%;
    background: #EFEFEF;
    padding: 25px 20px 20px;
    border-radius: 15px;
    position: relative;
`;

export const SocialMediaUnorderedList = styled.ul`
    width: 100%;
    margin: 0;
    padding-left: 0px;
    list-style: none;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: 23px;
`;

export const SocialMediaText = styled.p`
    color:#000000;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;
    margin: 0;
`;

export const SocialMediaStrong = styled.strong`
    color: #01606F;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 22px;

`;

export const SocialMediaUListView = styled.li`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    column-gap: 15px;

    @media screen and (max-width: 575px){
        flex-direction: column;
        row-gap: 15px;
    }
`;

export const SocialMediaIcon = styled.div`
    min-width: 36px;
    min-height: 36px;
    background: #4267B2;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    &.twitter-icon-bg{
        background: #000000;
    }
    &.doubleQuotes-icon-bg{
        width: 50px;
        height: 50px;
        background: #33A7AE;
        margin-bottom: -25px;
        position: relative;
        margin-left: 20px;
        z-index: 1;

        @media screen and (max-width: 575px){
            width: 40px;
            height: 40px;
        }
        
        img{
            max-width: 30px;
            @media screen and (max-width: 575px){
                max-width: 24px;
            }
        }
    }
    img{
        max-width: 18px;
        display: block;
    }
`;

export const IdeasCollectingReviewsWrap = styled.div`

`;

export const IdeasCollectingReviewsContent = styled.text`
    width: 100%;
    color: #000000;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    line-height: 24px;
    margin: 20px 0;
    display: block;
`;

export const ReviewsClientName = styled.h6`
    color: #000000;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 24px;
`;


export const ReviewsClientNameSpan = styled.span`
    color: #01606F;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 24px;
`;



export const ReviewDashSpan = styled.span`
    &.dash-review {
        position: relative;
        padding-left: 20px;
    &:after {
        width: 18px;
        position: absolute;
        height: 2px;
        content: "";
        background: #000;
        top: 11px;
        left: -1px;
    }


`;